module.exports = __webpack_public_path__ + "img/icn-tablet.aaabccd6.svg";